
exports.isBrowser = typeof window !== 'undefined';



//////////////////
// WEBPACK FOOTER
// ./node_modules/jsondiffpatch/src/environment.js
// module id = 648
// module chunks = 0